/* eslint-disable */
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/index';

import HTTP, { HTTPV } from './utils/http-common';
// Libraries//

import { IS_DEV_ENV, getPortalFromPath } from './utils/tools';
import { isMicrosoftSignInPopup } from './utils/microsoftSignIn';
import { roundCeilTo } from '@mtntop/utils/shared/helpers/money';
import { ADMIN_PASSWORD_POLICY, checkPassword, describePolicy } from '@mtntop/utils/shared/helpers/password';
import BootstrapVue from 'bootstrap-vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import Lists from '../libs/components/Lists';
import TypoGraphy from './components/Typography.vue';
import Forms from '../libs/components/FormBuilder/Builder';
import Map from '../libs/components/GoogleMap';
import AdvancedInput from '../libs/components/AdvancedInput';
import Upload from '../libs/components/Upload';
import PopulateAddress from './components/PopulateAddress';
import _ from 'lodash'; // Without this, lodash won't be global!
import dayjs from '@/plugins/dayjs';
import flatPickr from 'vue-flatpickr-component';
import VeeValidate from 'vee-validate';
import Notifications from 'vue-notification';
import VueJsonPretty from 'vue-json-pretty';
import notificationMixin from '@/mixins/notificationMixin';
import mapMixin from '@/mixins/mapMixin';
import dateMixin from '@/mixins/dateMixin';
import textMixin from '@/mixins/textMixin';
import psErrorsMixin from '@/mixins/psErrorsMixin';
import constantsMixin from '@/mixins/constantsMixin';
import Vue2Filters from 'vue2-filters';
import VueGtm from 'vue-gtm';
import VueLazyLoad from 'vue-lazyload';
import VueClipboards from 'vue-clipboards';
import LiquorTree from 'liquor-tree';
import AsyncComputed from 'vue-async-computed';
import TopBreadcrumbs from '@mtntop/utils/src/plugins/topBreadcrumbsInit';
import TopTable from '@mtntop/utils/src/plugins/topTableInit';
import validatedInputInit from '@mtntop/utils/src/plugins/mpowerInputsInit';
import { initGTagForVue } from '@mtntop/utils/src/plugins/gtag';

import introJs from 'intro.js';
import AddressFields from '@mtntop/utils/src/components/AddressFields';
import ArrayCard from './components/ArrayCard';
import ArrayTableCard from './components/ArrayTableCard';
import ValidatedNumberField from './components/ValidatedNumberField';
import VueHighlightJS from 'vue-highlightjs';
import VueContentLoading from 'vue-content-loading';
import { codemirror } from 'vue-codemirror';
import { postcodeValidator } from 'postcode-validator';
import MpowerDesigner from '@mtntop/utils/src/components/Designer';
import VueMeta from 'vue-meta';
import VueCardFormat from 'vue-credit-card-validation';
import VueHtmlToPaper from 'vue-html-to-paper';


// CSS
import 'bootstrap';
//import './assets/scss/bootstrap.scss';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-image-lightbox/dist/vue-image-lightbox.min.css';
import 'codemirror/lib/codemirror.css';
import 'codemirror/addon/display/autorefresh.js';

import 'flatpickr/dist/flatpickr.css';

import 'froala-editor/js/plugins.pkgd.min.js';
//Import third party plugins
import 'froala-editor/js/third_party/embedly.min';
import 'froala-editor/js/third_party/font_awesome.min';
// Import Froala Editor css files.
import 'froala-editor/css/froala_editor.pkgd.min.css';

import './assets/fontawesome/css/all.css';
import './assets/scss/style.scss';
import './utils/chartDarkBackgroundPlugin';

// themes
import 'codemirror/theme/base16-light.css';
import 'codemirror/theme/eclipse.css';
import 'codemirror/theme/monokai.css';
import 'codemirror/addon/fold/foldgutter.css';
import 'codemirror/addon/dialog/dialog.css';

// modes
import 'codemirror/mode/xml/xml.js';
import 'codemirror/mode/css/css.js';
import 'codemirror/mode/javascript/javascript.js';
import 'codemirror/mode/htmlmixed/htmlmixed';

// addons
import 'codemirror/addon/edit/closetag';
import 'codemirror/addon/hint/show-hint.js';
import 'codemirror/addon/hint/xml-hint';
import 'codemirror/addon/hint/html-hint';
import 'codemirror/addon/fold/foldcode';
import 'codemirror/addon/fold/brace-fold';
import 'codemirror/addon/fold/xml-fold';
import 'codemirror/addon/fold/markdown-fold';
import 'codemirror/addon/fold/foldgutter';
import 'codemirror/addon/search/search';
import 'codemirror/addon/search/searchcursor';
import 'codemirror/addon/search/jump-to-line';
import 'codemirror/addon/dialog/dialog';
import 'codemirror/addon/scroll/simplescrollbars';

import './assets/fontawesome/css/all.css';

import { mapGetters } from 'vuex';
import ActionButtonModal from './components/ActionButtonModal';
import ActionButton from './components/ActionButton';
import DeleteButton from './components/DeleteButton';
import DownloadFile from './components/DownloadFile';
import QuillEditorVue from '../libs/components/QuillEditor.vue';
// directives
import VueSticky from '../libs/directives/sticky';
import 'intro.js/introjs.css';
import './assets/scss/style.scss'; //This should always be last

console.log('build success');

window.addEventListener('unhandledrejection', (event) => {
  event.preventDefault();
});

Vue.use(VueCardFormat);
Vue.use(VeeValidate, { fieldsBagName: 'veeFields' });

function vvFirstBound(ref, key) {
  if (ref == null || ref === false) return NaN;
  if (typeof ref === 'number' && Number.isFinite(ref)) return ref;
  if (typeof ref === 'string') {
    const n = parseFloat(ref.trim());
    return Number.isFinite(n) ? n : NaN;
  }
  if (Array.isArray(ref) && ref.length) {
    const n = parseFloat(ref[0]);
    return Number.isFinite(n) ? n : NaN;
  }
  if (typeof ref === 'object') {
    if (key && ref[key] != null) {
      const n = parseFloat(ref[key]);
      if (Number.isFinite(n)) return n;
    }
    if (Object.prototype.hasOwnProperty.call(ref, '0')) {
      const n = parseFloat(ref[0]);
      if (Number.isFinite(n)) return n;
    }
    const vals = Object.values(ref);
    for (let i = 0; i < vals.length; i += 1) {
      const n = parseFloat(vals[i]);
      if (Number.isFinite(n)) return n;
    }
  }
  return NaN;
}

VeeValidate.Validator.extend('maxVal', {
  //standart max work only with digits
  getMessage(field, params, data) {
    const t = vvFirstBound(params, 'maxVal');
    return `Field should be max ${Number.isFinite(t) ? t : params}`;
  },
  validate: (value, ref) => {
    const v = parseFloat(typeof value === 'number' ? value : String(value ?? '').trim());
    const t = vvFirstBound(ref, 'maxVal');
    if (!Number.isFinite(v) || !Number.isFinite(t)) return false;
    return v - 1e-10 <= t;
  }
});
VeeValidate.Validator.extend('lowercase', {
  getMessage: (field) => `${field} must contain only lowercase letters`,
  validate: (value) => /^[a-z0-9-_]+$/.test(value)
});
VeeValidate.Validator.extend('statementDescriptor', {
  //standart max work only with digits
  getMessage(field, params, data) {
    return `Contains between 5 and 22 Latin characters`;
  },
  validate: (value, [testProp]) => {
    return !value || (value && (value.match(/[a-zA-Z\ ]{5,20}/g) || [''])[0].length === value.length);
  }
});
VeeValidate.Validator.extend('decimals', {
  validate: (value, { decimals = '*', separator = '.' } = {}) => {
    if (value === null || value === undefined || value === '') {
      return {
        valid: false
      };
    }
    if (Number(decimals) === 0) {
      return {
        valid: /^-?\d*$/.test(value)
      };
    }
    const regexPart = decimals === '*' ? '+' : `{1,${decimals}}`;
    const regex = new RegExp(`^[-+]?\\d*(\\${separator}\\d${regexPart})?([eE]{1}[-]?\\d+)?$`);

    return {
      valid: regex.test(value)
    };
  },
  message: 'The {_field_} field must contain only decimal values'
});
VeeValidate.Validator.extend(
  'postalCode',
  {
    validate: (value, { country, ...rest }) => {
      try {
        return postcodeValidator(value, country);
      } catch (e) {
        if (e.toString().match(/Invalid country code/)) {
          return true;
        }
        return false;
      }
    },
    getMessage: (field) => {
      return `The ${field} code is not valid for the selected country.`;
    }
  },
  {
    paramNames: ['country']
  }
);
VeeValidate.Validator.extend('minVal', {
  getMessage(field, params, data) {
    const t = vvFirstBound(params, 'minVal');
    return `Field must be at least ${Number.isFinite(t) ? t : params}`;
  },
  validate: (value, ref) => {
    const v = parseFloat(typeof value === 'number' ? value : String(value ?? '').trim());
    const t = vvFirstBound(ref, 'minVal');
    if (!Number.isFinite(v) || !Number.isFinite(t)) return false;
    return v + 1e-10 >= t;
  }
});
VeeValidate.Validator.extend('increment', {
  getMessage(field, params) {
    return `Field should be divisible by ${params}`;
  },
  validate: (value, [testProp]) => {
    return parseInt(value) % parseFloat(testProp) === 0;
  }
});
VeeValidate.Validator.extend('passwordRules', {
  getMessage: () => describePolicy(ADMIN_PASSWORD_POLICY),
  validate: (value) => checkPassword(value, ADMIN_PASSWORD_POLICY).valid
});
if (process.env.VUE_APP_SENTRY_DSN) {
  (function initSentry() {
    const script = document.createElement('script');
    script.onload = function () {
      window.Sentry.init({
        dsn: process.env.VUE_APP_SENTRY_DSN,
        integrations: [new window.Sentry.Integrations.BrowserTracing()],
        ignoreErrors: [/ResizeObserver loop (limit exceeded|completed with undelivered notifications)/],
        tracesSampleRate: 0.1,
        sampleRate: 1.0
      });
    };
    script.setAttribute('src', 'https://browser.sentry-cdn.com/6.11.0/bundle.tracing.min.js');
    document.body.appendChild(script);
  })();
}

Vue.use(VueHighlightJS);
Vue.use(AsyncComputed);
Vue.mixin(notificationMixin);
Vue.mixin(mapMixin);
Vue.mixin(dateMixin);
Vue.mixin(textMixin);
Vue.mixin(psErrorsMixin);
Vue.mixin(constantsMixin);
Vue.prototype.$moment = dayjs;
window.moment = dayjs;
// keep 'moment' filter name so all existing templates stay unchanged
Vue.filter('moment', (value, format) => value ? dayjs(value).format(format) : '');
Vue.use(flatPickr);
Vue.use(BootstrapVue);
Vue.use(Notifications);
Vue.use(VueMeta);

Vue.use(Vue2Filters);
Vue.use(VueLazyLoad, {
  error: 'img/loading-img.png',
  loading: 'img/loading-img.png'
});
Vue.use(VueClipboards);
Vue.use(LiquorTree);
Vue.component('mpower-designer', MpowerDesigner);

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_API
  }
});

Vue.use(validatedInputInit); //validated-input, autocomplete-input, multiselect
Vue.use(TopTable); //has top-table, pagination-list
Vue.use(TopBreadcrumbs); //breadcrumbs

Vue.prototype.introJs = introJs;
Vue.component('codemirror', codemirror);
Vue.component('lists', Lists);
Vue.component('typo-graphy', TypoGraphy);
Vue.component('quill-editor', QuillEditorVue);
Vue.component('forms', Forms);
Vue.component('google-map', Map);
Vue.component('advanced-input', AdvancedInput);
Vue.component('upload', Upload);
Vue.component('vue-json-pretty', VueJsonPretty);
Vue.component('populate-address', PopulateAddress);
Vue.component('address-fields', AddressFields);
Vue.component('array-card', ArrayCard);
Vue.component('array-table-card', ArrayTableCard);
Vue.component('validated-number-field', ValidatedNumberField);
Vue.component('vue-content-loading', VueContentLoading);
Vue.component('delete-button', DeleteButton);
Vue.component('action-button', ActionButton);
Vue.component('action-button-modal', ActionButtonModal);
Vue.component('download-file', DownloadFile);
Vue.component('loading', {
  template:
    '<div data-id="mpower-loading" class="text-center d-flex justify-content-center align-items-center h-100">\n' +
    '<i class="far fa-spinner-third fa-spin fa-3x text-primary"></i>\n' +
    '</div>\n'
});

Vue.filter('currencyDecimal', function (value) {
  if (!value) return '0';
  value = parseFloat(value).toFixed(2);
  return `$${value.split('.')[0]}`;
});
Vue.filter('list', function (value = [], propName = 'name', divider = ', ') {
  return value.map((i) => i[propName]).join(divider);
});
Vue.filter('dateWithTime', function (value) {
  return (value && dayjs(value).format('M/D/YYYY hh:mmA')) || '-';
});

Vue.filter('date', function (value) {
  return (value && dayjs(value).format('MM/DD/YYYY')) || '-';
});

Vue.mixin({
  data() {
    return {
      VUE_APP_PS_API_URL: process.env.VUE_APP_PS_API_URL || process.env.VUE_APP_PS_API_URL_TEMP,
      loaded: false
    };
  },
  computed: {
    formType() {
      return Object.keys(this.$route.params).length ? 'Edit' : 'Create';
    },
    toolTip() {
      return `<p>Upgrade your plan to use this feature.</p> <a href="https://mpowerpromo.com/contact" target="_blank" class="btn btn-primary btn-sm">Upgrade</a> <a href="https://mpowerpromo.com/pricing" target="_blank" class="btn btn-link btn-sm">View Plans</a>`;
    },
    portalRootLink() {
      const PORTAL = (this.$route.path.split('/').filter((el) => el)[0] || '').toLowerCase();
      if (['admin', 'supplier', 'art', 'production', 'promostandards'].includes(PORTAL)) {
        return '/' + PORTAL;
      } else {
        return '';
      }
    },
    isAdminPortal() {
      return this.portalRootLink === '/admin';
    },
    isSupplierPortal() {
      return this.portal === 'supplier';
    },
    isArtPortal() {
      return this.portal === 'art';
    },
    isDistributorPortal() {
      return this.portal === 'app';
    },
    portal() {
      return getPortalFromPath(this.$route.path);
    },
    http() {
      return HTTP;
    },
    $http() {
      return HTTP;
    },
    ...mapGetters([
      'loggedInUser',
      'isSuperAdmin',
      'isDistributorAdmin',
      'isSupplierAdmin',
      'isManagerOrExecutive'
    ]),
    distributorCurrencySign() {
      return this.loggedInUser?.distributorId?.currency?.sign || '$';
    }
  },
  methods: {
    currency(value, symbol, decimals, options) {
      var thousandsSeparator, symbolOnLeft, spaceBetweenAmountAndSymbol;
      var digitsRE = /(\d{3})(?=\d)/g;
      options = options || {};
      value = parseFloat(value);
      if (!isFinite(value) || (!value && value !== 0)) return '';
      symbol = symbol != null ? symbol : '$';
      decimals = decimals != null ? decimals : 2;
      thousandsSeparator = options.thousandsSeparator != null ? options.thousandsSeparator : ',';
      symbolOnLeft = options.symbolOnLeft != null ? options.symbolOnLeft : true;
      spaceBetweenAmountAndSymbol =
        options.spaceBetweenAmountAndSymbol != null ? options.spaceBetweenAmountAndSymbol : false;
      var stringified = Math.abs(value).toFixed(decimals);
      stringified = options.decimalSeparator ? stringified.replace('.', options.decimalSeparator) : stringified;
      var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
      var i = _int.length % 3;
      var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? thousandsSeparator : '') : '';
      var _float = decimals ? stringified.slice(-1 - decimals) : '';
      symbol = spaceBetweenAmountAndSymbol ? (symbolOnLeft ? symbol + ' ' : ' ' + symbol) : symbol;
      symbol = symbolOnLeft
        ? symbol + head + _int.slice(i).replace(digitsRE, '$1' + thousandsSeparator) + _float
        : head + _int.slice(i).replace(digitsRE, '$1' + thousandsSeparator) + _float + symbol;
      var sign = value < 0 ? '-' : '';
      return sign + symbol;
    },
    getSearchSupplierLink(productId, site, productName = '') {
      return `http://www.google.com/search?q=${site}+${productId}+${productName}`;
    },
    formatFloats(obj, keys, noRoundCeil = false) {
      if (!obj || !Array.isArray(keys)) return;
      for (let i = 0; i < keys.length; i++) {
        if (typeof obj[keys[i]] === 'number') {
          if (noRoundCeil) {
            obj[keys[i]] = parseFloat(obj[keys[i]]);
          } else {
            obj[keys[i]] = parseFloat(roundCeilTo(obj[keys[i]], 2));
          }
        }
      }
    },
    isoToLocal(value) {
      const startTime = new Date(value);
      return dayjs(new Date(startTime.getTime() + startTime.getTimezoneOffset() * 60000)).toISOString();
    },
    isoLocal(value) {
      const startTime = new Date(value);
      return dayjs(new Date(startTime.getTime() - startTime.getTimezoneOffset() * 60000));
    },
    notifySuccess(text) {
      Vue.notify({
        group: 'app',
        type: 'success',
        duration: IS_DEV_ENV ? 400 : 3000,
        text,
        closeOnClick: true
      });
    },
    notifyError(text) {
      Vue.notify({
        group: 'app',
        type: 'error',
        title: 'Error',
        closeOnClick: true,
        duration: IS_DEV_ENV ? 400 : 30000,
        text
      });
    },

    validateState(ref, validState = null) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        if (!this.errors.has(ref)) {
          return validState;
        } else {
          return false;
        }
      }
      return null;
    },
    kebabCase(str) {
      return _.kebabCase(str);
    }
  },
  directives: {
    sticky: VueSticky
  }
});

Vue.use(VueGtm, {
  //
  id: process.env.VUE_APP_GTM_ID, // Your GTM ID
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: false, // Whether or not display console logs debugs (optional)
  vueRouter: router // Pass the router instance to automatically sync with router (optional)
});

const env = process.env.VUE_APP_ENV || process.env.NODE_ENV || 'local';
const { gtag, dataLayer } = initGTagForVue(env, 'app');
Vue.prototype.$gtag = gtag;
Vue.prototype.$dataLayer = dataLayer;

Vue.config.productionTip = false;
Vue.config.ignoredElements = ['released-badge', 'released-widget', 'released-page'];

const htmlToPaperOptions = {
  name: '_blank',
  specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
  styles: ['https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css']
};
Vue.use(VueHtmlToPaper, htmlToPaperOptions);

store.dispatch('theme/initTheme');

export const eventBus = new Vue();
// the popup only hands its fragment to the opener; a booted app could redirect and drop it
if (!isMicrosoftSignInPopup()) {
  new Vue({
    router,
    store,
    render: (h) => h(App)
  }).$mount('#app');
}

(function () {
  try {
    function assignStyles(dom) {
      if (!dom) return;
      assignStyle(dom);
      for (let i = 0; i < dom.children.length; i++) {
        assignStyles(dom.children[i]);
      }
    }
    const styles = [
      'display',
      'justifyContent',
      'alignItems',
      'flexDirection',
      'borderRadius',
      'width',
      'backgroundColor',
      'color',
      'fontSize',
      'textAlign',
      'margin',
      'padding',
      'border'
    ];

    function assignStyle(dom) {
      const style = window.getComputedStyle(dom);
      styles.forEach((s) => {
        dom.style[s] = style[s];

        /*
        if (s === 'width') {
          dom.style['maxWidth'] = `${parseInt(style[s]) - 2 * parseInt(style.padding)}px`;
        } else {
          dom.style[s] = style[s];
        }
        */
      });
    }
    function postMessage(e) {
      if (e.data === 'printTempContainer') {
        assignStyles(document.getElementById('tempContainer'));
      }
    }
    window.addEventListener('message', postMessage, false);
    window.addEventListener('unhandledrejection', (e) => {
      if (/resizeobserver/.test(e?.message || e || '').toString()) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    });
    new ResizeObserver(
      _.debounce((entries) => {
        window.requestAnimationFrame(() => {
          if (!Array.isArray(entries) || !entries.length) {
            return;
          }
          // Your code
        });
      }, 100)
    );
  } catch (e) {
    console.log(e);
  }
})();
